import { Toolbar, SaveButton, DeleteButton } from "react-admin";
import { useAuth } from "../../hooks/useAuth";

// Delete controls, gated on who can actually delete. Deletes are locked to full
// Applied GA admins app-wide (backend requireFullAdmin / super-admin
// deleteMiddleware), so Lite Admins (#73), agency principals, and read-only staff
// never get a working delete. These helpers hide the delete UI that would 403 for
// them, so "no ability to delete" is true in the UI as well as the API.

// A SimpleForm toolbar showing Delete only for users who can delete; Save only
// for everyone else.
export const SaveWithDeleteToolbar = (props) => {
  const { user, canDelete } = useAuth();
  return (
    <Toolbar {...props}>
      <SaveButton />
      {canDelete(user) && <DeleteButton />}
    </Toolbar>
  );
};

// Value for <Datagrid bulkActionButtons>: false (no bulk actions, i.e. no bulk
// delete) for anyone who can't delete, otherwise the default.
export const useBulkActionButtons = () => {
  const { user, canDelete } = useAuth();
  return canDelete(user) ? undefined : false;
};
